@for (interest of _interests; track $index) {
    <div class="hrRow ap-padding-2 ap-margin-bottom-2 ap-flex ap-flex-wrap ap-justify-content-gt-sm-around ap-justify-content-lt-md-start">
        <div class="ap-flex-basis-lt-md-100">
            <ap-icon name="logo-asn" title="Logo ASN bank" size="80px 30px"> </ap-icon>
        </div>
        <div class="ap-flex-basis-50 ap-flex-basis-lt-md-75 ap-margin-auto">
            {{ interest.name }}
        </div>

        <div class="hrBold ap-flex-basis-lt-md-25 ap-text-align-right ap-margin-auto">
            {{ interest.interestRate | number: '1.2-2' : 'nl' }}%
        </div>
    </div>
}
